<template>
  <div
    class="ts-fixed ts-w-full ts-h-full ts-flex ts-flex-col ts-top-0 ts-left-0 ts-bottom-0 ts-right-0"
    style="z-index: 99998"
  >
    <div>
      <!-- begin login-cover -->
      <div class="login-cover">
        <div
          class="login-cover-image"
          v-bind:style="{ backgroundImage: 'url(' + bg.activeImg + ')' }"
        ></div>
        <div class="login-cover-bg"></div>
      </div>
      <!-- end login-cover -->

      <!-- begin login -->
      <div class="login login-v2" data-pageload-addclass="animated fadeIn">
        <!-- begin brand -->
        <div class="login-header">
          <div class="brand ts-text-center">
            <div class="ts-w-full ts-flex ts-justify-center">
              <img
                class="ts-rounded-full ts-w-40 ts-h-40 ts-flex ts-items-center ts-justify-center ts-object-cover"
                :src="photo"
                @error="onError"
                alt=""
              />
            </div>
            <b class="ts-uppercase">{{ name }}</b>
          </div>
          <!-- <div class="icon">
            <i class="fa fa-lock"></i>
          </div> -->
        </div>
        <!-- end brand -->
        <!-- begin login-content -->
        <div class="login-content">
          <form @submit.prevent="login" class="margin-bottom-0">
            <div class="form-group m-b-20">
              <input
                :type="input_type"
                class="form-control form-control-lg"
                placeholder="Password"
                required
                v-model.trim="model.password"
                @keyup.enter="onUnlock"
                ref="password"
              />
              <a href="#" @click.prevent="showPassword">
                <i
                  v-if="input_type === 'text'"
                  class="toggle-password fas fa-eye"
                ></i>
                <i v-else class="toggle-password fa fa-fw fa-eye-slash"></i>
              </a>
            </div>
            <div
              class="alert alert-danger fade show m-b-20"
              v-if="errors.has('password')"
            >
              {{ errors.first('password') }}
            </div>
            <div class="login-buttons">
              <ts-button
                type="submit"
                @click.prevent="onUnlock"
                class="btn btn-success btn-block btn-lg"
                :waiting="waiting"
              >
                Sign me in
              </ts-button>
            </div>
            <div class="m-t-20">
              POWERED BY: TECHSTORE CREATIVE SOLUTIONS
            </div>
          </form>
        </div>
        <!-- end login-content -->
      </div>
      <!-- end login -->

      <!-- begin login-bg -->
      <ul class="login-bg-list clearfix">
        <li v-bind:class="{ active: bg.bg1.active }">
          <a
            href="javascript:;"
            v-on:click="select('bg1')"
            v-bind:style="{ backgroundImage: 'url(' + bg.bg1.img + ')' }"
          ></a>
        </li>
        <li v-bind:class="{ active: bg.bg2.active }">
          <a
            href="javascript:;"
            v-on:click="select('bg2')"
            v-bind:style="{ backgroundImage: 'url(' + bg.bg2.img + ')' }"
          ></a>
        </li>
        <li v-bind:class="{ active: bg.bg3.active }">
          <a
            href="javascript:;"
            v-on:click="select('bg3')"
            v-bind:style="{ backgroundImage: 'url(' + bg.bg3.img + ')' }"
          ></a>
        </li>
        <li v-bind:class="{ active: bg.bg4.active }">
          <a
            href="javascript:;"
            v-on:click="select('bg4')"
            v-bind:style="{ backgroundImage: 'url(' + bg.bg4.img + ')' }"
          ></a>
        </li>
        <li v-bind:class="{ active: bg.bg5.active }">
          <a
            href="javascript:;"
            v-on:click="select('bg5')"
            v-bind:style="{ backgroundImage: 'url(' + bg.bg5.img + ')' }"
          ></a>
        </li>
        <li v-bind:class="{ active: bg.bg6.active }">
          <a
            href="javascript:;"
            v-on:click="select('bg6')"
            v-bind:style="{ backgroundImage: 'url(' + bg.bg6.img + ')' }"
          ></a>
        </li>
        <li v-bind:class="{ active: bg.bg7.active }">
          <a
            href="javascript:;"
            v-on:click="select('bg7')"
            v-bind:style="{ backgroundImage: 'url(' + bg.bg7.img + ')' }"
          ></a>
        </li>
      </ul>
      <!-- end login-bg -->
    </div>
  </div>
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'TsLockScreen',
  created() {
    PageOptions.pageEmpty = true
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    next()
  },
  data() {
    return {
      default_user: require('../../assets/default_user.jpg'),
      waiting: false,
      errors: new Errors(),
      input_type: 'password',
      model: {
        password: null
      },
      bg: {
        activeImg: require('@/assets/img/login-bg/login-bg-1.jpg'),
        bg1: {
          active: true,
          img: require('@/assets/img/login-bg/login-bg-1.jpg')
        },
        bg2: {
          active: false,
          img: require('@/assets/img/login-bg/login-bg-2.jpg')
        },
        bg3: {
          active: false,
          img: require('@/assets/img/login-bg/login-bg-3.jpg')
        },
        bg4: {
          active: false,
          img: require('@/assets/img/login-bg/login-bg-4.jpg')
        },
        bg5: {
          active: false,
          img: require('@/assets/img/login-bg/login-bg-5.jpg')
        },
        bg6: {
          active: false,
          img: require('@/assets/img/login-bg/login-bg-6.jpg')
        },
        bg7: {
          active: false,
          img: require('@/assets/img/login-bg/login-bg-7.jpg')
        }
      }
    }
  },
  mounted() {
    this.$refs.password.focus()
  },
  computed: {
    isLock() {
      return this.$store.state.isLockScreen
    },
    currentYear() {
      return moment().year()
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    name() {
      return this.$store.state.authUser.full_name
    },
    photo() {
      let p = this.$store.state.authUser
        ? this.$store.state.authUser.user_profile
        : null
      if (p) {
        return p
      }
      return this.default_user
    }
  },
  methods: {
    checkForm: function(e) {
      e.preventDefault()
      this.$router.push({ path: '/dashboard/v2' })
    },
    select: function(x) {
      this.bg.bg1.active = false
      this.bg.bg2.active = false
      this.bg.bg3.active = false
      this.bg.bg4.active = false
      this.bg.bg5.active = false
      this.bg.bg6.active = false
      this.bg.bg7.active = false

      this.$refs.password.focus()

      switch (x) {
        case 'bg1':
          this.bg.bg1.active = true
          this.bg.activeImg = this.bg.bg1.img
          break
        case 'bg2':
          this.bg.bg2.active = true
          this.bg.activeImg = this.bg.bg2.img
          break
        case 'bg3':
          this.bg.bg3.active = true
          this.bg.activeImg = this.bg.bg3.img
          break
        case 'bg4':
          this.bg.bg4.active = true
          this.bg.activeImg = this.bg.bg4.img
          break
        case 'bg5':
          this.bg.bg5.active = true
          this.bg.activeImg = this.bg.bg5.img
          break
        case 'bg6':
          this.bg.bg6.active = true
          this.bg.activeImg = this.bg.bg6.img
          break
        case 'bg7':
          this.bg.bg7.active = true
          this.bg.activeImg = this.bg.bg7.img
          break
      }
    },
    ...mapActions('user', ['unlock']),
    onUnlock() {
      this.waiting = true
      this.errors = new Errors()
      this.unlock(this.model)
        .then(() => {
          this.$store.commit('setIsLock', false)
          this.$emit('reset')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          if (error.message == 'Unauthenticated.') {
            this.$store.commit('setIsLock', false)
            this.$emit('reset')
            this.logout()
          }
        })
        .finally(() => {
          this.waiting = false
          this.model.password = null
        })
    },
    async logout() {
      await this.$store.dispatch('logout').then(() => {
        this.$router.push({ name: 'login' })
      })
    },
    onError() {
      event ? (event.target.src = this.default_user) : ''
    },
    showPassword() {
      if (this.input_type === 'password') {
        this.input_type = 'text'
      } else {
        this.input_type = 'password'
      }
    }
  }
}
</script>
<style scoped>
.login-cover-bg {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 0, 0, 0.45)),
    to(rgba(0, 0, 0, 0.9))
  );
}
.toggle-password {
  float: right;
  cursor: pointer;
  margin-right: 10px;
  margin-top: -30px;
  font-size: 15px;
}
</style>
